import { render, staticRenderFns } from "./op-data-entry-details-tabs.vue?vue&type=template&id=5ce7b267&scoped=true"
import script from "./op-data-entry-details-tabs.ts?vue&type=script&lang=js&external"
export * from "./op-data-entry-details-tabs.ts?vue&type=script&lang=js&external"
import style0 from "./op-data-entry-details-tabs.vue?vue&type=style&index=0&id=5ce7b267&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce7b267",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ce7b267')) {
      api.createRecord('5ce7b267', component.options)
    } else {
      api.reload('5ce7b267', component.options)
    }
    module.hot.accept("./op-data-entry-details-tabs.vue?vue&type=template&id=5ce7b267&scoped=true", function () {
      api.rerender('5ce7b267', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/operational-data/op-data-entry-details/tabs/op-data-entry-details-tabs/op-data-entry-details-tabs.vue"
export default component.exports